interface BookmarkSavedDateProps {
  date: string;
}

export function BookmarkSavedDate({ date }: BookmarkSavedDateProps) {
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(date));

  return (
    <span className="whitespace-nowrap text-data-card-xs text-data-card-date">
      Saved {formatted}
    </span>
  );
}
